var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.phoneFieldsContainer, _vm.editMode ? _vm.$style.phoneFieldsContainerEditing : '']
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.labelContainer
  }, [_c('div', [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(" " + _vm._s(_vm.phoneLabel) + ": "), _vm.isRequired && _vm.editMode && !_vm.options.hideAsterisk ? _c('span', {
    class: _vm.$style.requiredAsterisk,
    attrs: {
      "data-required-asterisk": ""
    }
  }, [_vm._v("*")]) : _vm._e()])])]), !_vm.editMode ? [_c('div', {
    class: _vm.$style.valueContainer
  }, [_vm.modelPhone ? _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s(_vm.formattedValue || 'N/A'))]) : _c('h4', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s('N/A'))]), _vm._t("afterValue")], 2)] : _vm._e(), _vm.editMode ? [_c('div', [_c('ValidationProvider', {
    staticClass: "d-contents",
    attrs: {
      "immediate": "",
      "debounce": 300,
      "name": _vm.phoneLabel,
      "rules": _vm.modelPhoneExt ? 'required|validPhoneNumber' : _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors,
          changed = _ref.changed;
        return [_c('BaseInputText', {
          class: _vm.$style.phoneField,
          attrs: {
            "mask": '###-###-####',
            "name": _vm.phoneLabel,
            "disabled": _vm.disabled,
            "error": errors[0],
            "placeholder": _vm.phonePlaceholder,
            "changed": changed
          },
          on: {
            "input": function input($event) {
              return _vm.onInput($event, 'phone');
            },
            "blur": function blur($event) {
              return _vm.$emit('blur');
            }
          },
          model: {
            value: _vm.modelPhone,
            callback: function callback($$v) {
              _vm.modelPhone = $$v;
            },
            expression: "modelPhone"
          }
        })];
      }
    }], null, false, 3722266057)
  })], 1)] : _vm._e()], 2)]), !_vm.hideExt && _vm.editMode ? _c('div', [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.labelContainer
  }, [_c('div', [_c('p', {
    staticClass: "p1",
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.phoneExtLabel) + ":")])])]), _vm.editMode ? [_c('div', [_c('ValidationProvider', {
    staticClass: "d-contents",
    attrs: {
      "debounce": 300,
      "name": _vm.phoneExtLabel
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var changed = _ref2.changed;
        return [_c('BaseInputText', {
          class: _vm.$style.extField,
          attrs: {
            "name": _vm.phoneExtLabel,
            "disabled": _vm.disabled,
            "placeholder": 'Ext.',
            "mask": '######',
            "changed": changed
          },
          on: {
            "input": function input($event) {
              return _vm.onInput($event, 'phoneExt');
            }
          },
          model: {
            value: _vm.modelPhoneExt,
            callback: function callback($$v) {
              _vm.modelPhoneExt = $$v;
            },
            expression: "modelPhoneExt"
          }
        })];
      }
    }], null, false, 1036694552)
  })], 1)] : _vm._e()], 2)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }